module.exports = " <div class=vc-nav-drawer v-show=show transition=slider-left> <div class=vc-nav-drawer-header> <slot name=header></slot> </div> <div class=vc-nav-drawer-content> <slot></slot> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/nav/navDrawer.vue
 ** module id = 468
 ** module chunks = 1
 **/